export interface ResourceScope {
    readonly active: boolean
    own(value: unknown): () => void
    guard<T extends (...args: any[]) => any>(callback: T): (...args: Parameters<T>) => ReturnType<T> | undefined
    timeout(callback: () => any, ms?: number): () => void
    interval(callback: () => any, ms: number): () => void
    listen(target: EventTarget, events: string | string[], callback: (...args: any[]) => any, options?: boolean | AddEventListenerOptions): () => void
    whenRemoved(node: Node, callback: () => any): () => void
    child(): ResourceScope
    dispose(): void
}

// The synchronous classic-script bootstrap shares this implementation with
// raw pages. No second ownership registry or React dependency is introduced.
export const createResourceScope = (): ResourceScope => (window as any).createResourceScope()
